<!-- Базовое контекстное меню для списков, таблиц и календаря. -->
<template>
  <Teleport to="body">
    <ul
      v-if="visible"
      class="base-context-menu"
      :style="{ top: y + 'px', left: x + 'px' }"
      @click.stop
    >
      <li
        v-for="item in items"
        :key="item.key"
        class="base-context-menu-item"
        @click="handleItemClick(item)"
      >
        <AppIcon
          v-if="item.iconName"
          class="context-menu-icon"
          :name="item.iconName"
          :size="14"
        />
        <span
          v-else-if="item.icon"
          class="context-menu-icon"
          v-html="item.icon"
        ></span>
        {{ item.label }}
      </li>
    </ul>
  </Teleport>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseContextMenu",
  components: {
    AppIcon,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close"],
  methods: {
    handleItemClick(item) {
      if (typeof item.action === "function") {
        item.action();
      }
      this.$emit("close");
    },
  },
};
</script>

<style>
.base-context-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 4px 0;
  min-width: 220px;
  user-select: none;
}

.base-context-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 14px;
  color: var(--color-dark);
  cursor: pointer;
}

.base-context-menu-item:hover {
  background-color: var(--color-grey);
}

.context-menu-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
